// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  width: 100%;
  margin-bottom: 6px;
  --inner-padding-start: 10px;
}

.checkbox-price {
  color: #b5b5b5;
}

.hidden {
  visibility: hidden;
}

.price {
  margin-right: 10px;
  color: var(--ion-color-black);
  font-weight: 400;
}

.qty__btn {
  width: 24px;
  height: 24px;
  margin: 0 !important;
  box-shadow: none;
  --box-shadow: none;
  display: flex;
  justify-content: center;
  align-items: center;
}
.qty__btn button {
  box-shadow: unset !important;
}
.qty__btn span {
  position: absolute;
  top: 50%;
  transform: translate(-3%, -57%);
  height: 15px;
}
.qty .qty-number {
  margin: 0 4px;
  text-align: center;
  min-width: 15px;
  color: var(--ion-color-secondary);
}

ion-checkbox {
  margin: 0 12px 0 0;
  --background: transparent;
  --background-checked: var(--ion-color-primary);
  --border-color: var(--ion-color-primary-shade);
  --border-color-checked: var(--ion-color-primary);
  --border-width: 1px;
  --checkmark-color: var(--color-white);
  --checkmark-width: 2px;
  --border-radius: var(--radius-default);
  --checkbox-background: transparent;
  --size: 20px;
}

app-tag {
  display: inline-block;
  margin-left: 5px;
}

ion-item {
  background: #ffffff;
  border-radius: 5px;
  margin-top: 10px;
  border: 0.5px solid #e2dcd5;
}

ion-label {
  font-size: 12px !important;
  font-family: AppFont, sans-serif;
  margin-right: 3px;
}

.pfand {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-multiple/article-option-group-multiple.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;EACA,2BAAA;AACD;;AAEA;EACC,cAAA;AACD;;AAEA;EACC,kBAAA;AACD;;AAEA;EACC,kBAAA;EACA,6BAAA;EACA,gBAAA;AACD;;AAGC;EACC,WAAA;EACA,YAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAAF;AAEE;EACC,4BAAA;AAAH;AAGE;EACC,kBAAA;EACA,QAAA;EACA,+BAAA;EACA,YAAA;AADH;AAKC;EACC,aAAA;EACA,kBAAA;EACA,eAAA;EACA,iCAAA;AAHF;;AAOA;EACC,kBAAA;EACA,yBAAA;EACA,8CAAA;EACA,8CAAA;EACA,gDAAA;EACA,mBAAA;EACA,qCAAA;EACA,sBAAA;EACA,sCAAA;EACA,kCAAA;EACA,YAAA;AAJD;;AAOA;EACC,qBAAA;EACA,gBAAA;AAJD;;AAMA;EACC,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,2BAAA;AAHD;;AAKA;EACC,0BAAA;EACA,gCAAA;EACA,iBAAA;AAFD;;AAKA;EACC,eAAA;AAFD","sourcesContent":["ion-item {\n\twidth: 100%;\n\tmargin-bottom: 6px;\n\t--inner-padding-start: 10px;\n}\n\n.checkbox-price {\n\tcolor: #b5b5b5;\n}\n\n.hidden {\n\tvisibility: hidden;\n}\n\n.price {\n\tmargin-right: 10px;\n\tcolor: var(--ion-color-black);\n\tfont-weight: 400;\n}\n\n.qty {\n\t&__btn {\n\t\twidth: 24px;\n\t\theight: 24px;\n\t\tmargin: 0 !important;\n\t\tbox-shadow: none;\n\t\t--box-shadow: none;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\n\t\tbutton {\n\t\t\tbox-shadow: unset !important;\n\t\t}\n\n\t\tspan {\n\t\t\tposition: absolute;\n\t\t\ttop: 50%;\n\t\t\ttransform: translate(-3%, -57%);\n\t\t\theight: 15px;\n\t\t}\n\t}\n\n\t.qty-number {\n\t\tmargin: 0 4px;\n\t\ttext-align: center;\n\t\tmin-width: 15px;\n\t\tcolor: var(--ion-color-secondary);\n\t}\n}\n\nion-checkbox {\n\tmargin: 0 12px 0 0;\n\t--background: transparent;\n\t--background-checked: var(--ion-color-primary);\n\t--border-color: var(--ion-color-primary-shade);\n\t--border-color-checked: var(--ion-color-primary);\n\t--border-width: 1px;\n\t--checkmark-color: var(--color-white);\n\t--checkmark-width: 2px;\n\t--border-radius: var(--radius-default);\n\t--checkbox-background: transparent;\n\t--size: 20px;\n}\n\napp-tag {\n\tdisplay: inline-block;\n\tmargin-left: 5px;\n}\nion-item {\n\tbackground: #ffffff;\n\tborder-radius: 5px;\n\tmargin-top: 10px;\n\tborder: 0.5px solid #e2dcd5;\n}\nion-label {\n\tfont-size: 12px !important;\n\tfont-family: AppFont, sans-serif;\n\tmargin-right: 3px;\n}\n\n.pfand {\n\tfont-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
